/**
 * Model for a mat.
 */
import { v4 as UUID } from 'uuid';

export class Mat {
    public id: string = null;
    public isNew: boolean = true;
    public name: string = null;
    public isActive: boolean = null;
    public sequence: number = null;
    public streamUrl: string = null;
    public eventId: string = null;

    public static getFields(): string[] {
        return [
            'name',
            'streamUrl',
            'isActive',
            'sequence',
            'eventId',
        ];
    }

    constructor(id: string = null, isNew: boolean = true) {
        this.id = id || UUID();
        this.isNew = isNew;
    }

    public clone(): Mat {
        const clone: Mat = new Mat();
        clone.id = this.id;
        clone.isNew = this.isNew;
        clone.name = this.name;
        clone.sequence = this.sequence;
        clone.streamUrl = this.streamUrl;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'mat';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.relationships = {};
        // Only allow updating the streamUrl
        json.data.attributes.streamUrl = this.streamUrl;

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any): Mat {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'];

        this.id = data['id'];
        this.isNew = false;
        this.name = attrs.name;
        this.eventId = attrs.eventId;
        this.streamUrl = attrs.streamUrl;
        this.sequence = attrs.sequence;
        this.isActive = attrs.isActive === true;

        return this;
    }
}
